<template>
  <v-container>
    <!-- OBJECTS DRAWER -->
    <QlikObjectDrawer 
      v-if="enableSwitch"
      :qAppId="app.qAppId"
      :show="!!selectedObject"
      @selected="selectNewObject"
      @closed="selectedObject = null"
    />

    <v-card 
      v-if="isGridEmpty && showEmpty" 
      class="text-h4 font-weight-thin mt-10" 
      color="transparent" 
      height="500px"
    >
      <v-row class="fill-height" align="center" justify="center">
        <v-col cols="8">
          <i18n path="Page.Warning.emptyGrid" tag="p">
            <template v-slot:icon>
              <v-icon large>auto_awesome_mosaic</v-icon>
            </template>
          </i18n>
        </v-col>
      </v-row>
    </v-card>

    <!-- Layout parser -->
    <v-row>
      <v-col 
        v-for="(column, indexCol) in layout" 
        :key="'col_' + indexCol" cols="12" 
        :lg="column.size"
        class="col-padding-override"
      >
        <v-row 
          v-for="(row, indexRow) in column.rows" 
          :key="'col_' + indexCol + 'row_' + indexRow"
        >
          <v-col 
            v-for="(object, indexObj) in row.objects" 
            :key="'col_' + indexCol + 'row_' + indexRow + 'obj_' + indexObj" 
            :cols="12 / row.objects.length"
            class="col-padding-override"
          >
            <v-card :height="row.height" :color="object.type === 'blank' ? 'transparent' : 'white'" :flat="!enableSwitch && object.type === 'blank'">
              <v-toolbar color="transparent" class="slot-toolbar" collapse flat dense>
                <v-spacer></v-spacer>
                <v-btn 
                  v-if="enableSwitch"  
                  icon 
                  @click="editObject(indexCol, indexRow, indexObj)"
                  color="secondary"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn 
                  v-else-if="object.type === 'QdtViz'"
                  icon 
                  color="secondary" 
                  @click="exportObject(indexCol, indexRow, indexObj)"
                >
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-toolbar>
              <QlikBox 
                v-if="object.type === 'QdtViz'" 
                :objectId="object.config.id"
                :height="row.height - 32 + 'px'"
                :integrator="$qlik[app.qAppId].integrator"
              />
            </v-card>    
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QlikObjectDrawer from '@/components/Qlik/QlikObjectDrawer'
import QlikBox from '@/components/Qlik/QlikBox'
import { mapMutations } from 'vuex'
export default {
  name: 'PageLayoutManager',
  components: { QlikBox, QlikObjectDrawer },
  props: {
    app: {type: Object, required: true},
    layout: {type: Array, required: true},
    enableSwitch: {type: Boolean, required: false},
    showEmpty: {type: Boolean, required: false}
  },
  data: () => ({
    selectedObject: null,
  }),
  computed: {
    isGridEmpty () {
      if (!this.layout.length) return true
      return this.layout.every(col => !col.rows.length)
    }
  },
  methods: {
    ...mapMutations('qlik', [
      'openExporter',
    ]),
    editObject(indexCol, indexRow, indexObject) {
      this.selectedObject = {
        indexCol,
        indexRow,
        indexObject
      }
    },
    exportObject (indexCol, indexRow, indexObj) {
      console.log(this.layout[indexCol].rows[indexRow].objects[indexObj].config)
      this.openExporter({
        qAppId: this.app.qAppId,
        qObjectId: this.layout[indexCol].rows[indexRow].objects[indexObj].config.id
      })
    },
    selectNewObject({qObjectId}) {
      const newObject = {
        type: 'QdtViz',
        config: {
          id: qObjectId,
          height: '300px'
        }
      }
      this.layout[this.selectedObject.indexCol].rows[this.selectedObject.indexRow].objects.splice(this.selectedObject.indexObject, 1, newObject)
      this.selectedObject = null
    }
  }
}
</script>

<style scoped>
.slot-toolbar {
  position: absolute;
  right: 0px;
  z-index: 5;
  width: 100%;
}
/** To allow col alignment */
.col-padding-override {
  padding: 10px!important;
}
</style>